import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Drawer from '@mui/material/Drawer'
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListAltIcon from '@mui/icons-material/ListAlt';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import ListItemButton from '@mui/material/ListItemButton';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {
    Equalizer,
    ContentPaste,
    RestaurantMenu,
    Layers,
    Devices,
    LocalPrintshop,
    Payment,
    Settings,
    Menu,
    HelpCenter,
    Assignment,
    Store,
    SpeakerNotes,
    Notifications,
    AccountCircle,
    ExitToApp,
    Group,
    Restaurant,
} from '@mui/icons-material';
import FeaturedPlayListOutlinedIcon from '@mui/icons-material/FeaturedPlayListOutlined';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { Image } from 'primereact/image';
import { ListItemIcon } from '@mui/material';
import { useMediaQuery } from 'react-responsive';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from "../contexts/AuthContext";
import { useCompanySetting } from '../contexts/CompanySettingContext';
import NestedMenuItem from './NestedMenuItems';

const SideNav = ({ items, navTitle }) => {
    const { auth, restaurantId } = useAuth()

    const [open, setOpen] = useState(true);
    const isSmallScreen = useMediaQuery({ maxWidth: 767 });
    const iconStyle = { color: "white", cursor: "pointer" }
    const location = useLocation();

    useEffect(() => {
        if (isSmallScreen) {
            setOpen(false)
            toggleDrawer(false)
        } else {
            setOpen(true)
            toggleDrawer(true)
        }
    }, [isSmallScreen]);

    const toggleDrawer = (open) => (event) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event.key === 'Tab') ||
                (event.key === 'Shift'))
        ) {
            return;
        }

        setOpen(open);
    };

    const userPermissions = auth.user?.is_super_admin ? auth.user?.permissions : auth?.user?.permissions?.find((restaurant) => restaurant.restaurant_id === restaurantId)?.permissions?.map(permission => permission.module) || [];

    const navItems = [
        { title: "Dashboards", icon: <Equalizer sx={iconStyle} />, to: "/admin/dashboard/view", parentMatch: location.pathname.includes("/admin/dashboard") },
        userPermissions.includes("reports") && { title: "Reports", icon: <ContentPaste sx={iconStyle} />, to: "/admin/report/receipt", parentMatch: location.pathname.includes("/admin/report") },
        userPermissions.includes("users") && { title: "Users", icon: <Group sx={iconStyle} />, to: "/admin/user/list", parentMatch: location.pathname.includes("/admin/user") },
        userPermissions.includes("products") && { title: "Products", icon: <Restaurant sx={iconStyle} />, to: "/admin/products/list", parentMatch: location.pathname.includes("/admin/products") },
        userPermissions.includes("products") && { title: "Combos", icon: <FastfoodIcon sx={iconStyle} />, to: "/admin/combos/list", parentMatch: location.pathname.includes("/admin/combos") },
        userPermissions.includes("table-floor") && { title: "Floors", icon: <Layers sx={iconStyle} />, to: '/admin/floor/create', parentMatch: location.pathname.includes("/admin/floor") },
        userPermissions.includes("printers") && { title: "Printers", icon: <LocalPrintshop sx={iconStyle} />, to: "/admin/printing/list", parentMatch: location.pathname.includes("/admin/printing") },
        // userPermissions.includes("devices") &&{ title: "Devices", icon: <Devices sx={iconStyle} />, to: "/admin/devices/list", parentMatch: location.pathname.includes("/admin/devices") },
        // { title: "Orders", icon: <ListAltIcon sx={iconStyle} />, to: "/admin/order/list", parentMatch: location.pathname.includes("/admin/order") },
        userPermissions.includes("payment-methods") && { title: "Payments", icon: <Payment sx={iconStyle} />, to: "/admin/payment/type", parentMatch: location.pathname.includes("/admin/payment") },
        userPermissions.includes("audits") && { title: "Audits", icon: <FeaturedPlayListOutlinedIcon sx={iconStyle} />, to: "/admin/audit/list", parentMatch: location.pathname.includes("/admin/audit") },

        userPermissions.includes("permissions") && { title: "Permissions", icon: <LockOpenIcon sx={iconStyle} />, to: "/admin/permissions", parentMatch: location.pathname.includes("/admin/permissions") },
        userPermissions.includes("restaurant") && { title: "Settings", icon: <Settings sx={iconStyle} />, to: "/admin/settings/restaurants", parentMatch: location.pathname.includes("/admin/settings/restaurants") },
        // { title: "Support", icon: <HelpCenter sx={iconStyle} /> },
        // { title: "Tasks", icon: <Assignment sx={iconStyle} /> },
    ].filter(Boolean);

    return (
        <>
            <div className={`sticky-top d-sm-block d-md-none`}>
                <div className="container">
                    <div className="row align-items-center justify-content-between">
                        <div className="col-auto">
                            <p className={`mb-0 text-2xl font-bold`}>{navTitle}</p>
                        </div>
                        <div className="col-auto">
                            <div
                                className="hamburgerMenu"
                                onClick={() => {
                                    setOpen((prev) => !prev);
                                }}
                            >
                                <span className="icon">
                                    <Menu />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isSmallScreen ? (
                <SwipeableDrawer
                    anchor="left"
                    open={open}
                    onClose={toggleDrawer(false)}
                    onOpen={toggleDrawer(true)}
                    sx={{
                        '& .MuiDrawer-paper': {
                            backgroundColor: '#212a3a',
                            color: 'white',
                        }
                    }}
                >
                    <SidebarContent navItems={navItems} iconStyle={iconStyle} items={items} navTitle={navTitle} />
                </SwipeableDrawer>
            ) : (
                <Drawer
                    sx={{
                        padding: '16px',
                        width: 270,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: 270,
                            height: "100%",
                            boxSizing: 'border-box',
                            backgroundColor: '#212a3a',
                            color: 'white',
                        },
                    }}
                    anchor="left"
                    variant="persistent"
                    open={open}
                >
                    <SidebarContent navItems={navItems} iconStyle={iconStyle} items={items} navTitle={navTitle} />
                </Drawer>
            )}
        </>
    );
};

const SidebarContent = ({ navItems, iconStyle, items, navTitle }) => {
    const { auth, logout } = useAuth();
    const navigate = useNavigate()
    const { companyLogo } = useCompanySetting();

    const handleLogout = async () => {
        await logout()
        navigate("/")
    }

    return (
        <Box
            sx={{
                width: "auto",
                backgroundColor: '#303c54',
                color: 'white',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <div className='d-flex flex-row icons_container'>
                <div className='icons_list'>
                    <h3 className="mx-3 my-2 pointerCursor" onClick={() => navigate("/admin/dashboard/view")}>
                        <img src={companyLogo ? companyLogo : ''} className='navLogo' />
                    </h3>
                    <List sx={{
                        '& .css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root': {
                            padding: '15px 18px',
                            margin: 0
                        }
                    }}>
                        {navItems.map((nav, index) => (
                            <NestedMenuItem key={index} item={nav} />
                        ))}
                    </List>
                </div>
                <div className='sub_nav_container'>
                    <h4 className="mx-3">
                        {navTitle}
                    </h4>
                    <List sx={{
                        '& .css-16ac5r2-MuiButtonBase-root-MuiListItemButton-root': {
                            padding: '10px 20px',
                            margin: 0
                        }
                    }}>
                        {items.map((nav, index) => (
                            <NestedMenuItem key={index} item={nav} />
                        ))}
                    </List>
                </div>
            </div>
            <Divider />
            <List sx={{
                backgroundColor: '#212a3a',
                color: 'white',
            }}>
                {/* <hr className="m-0" style={{ borderColor: '#020304 ' }} />
                <ListItem key="user_details" disablePadding>
                    <ListItemButton>
                        <ListItemIcon>
                            <Store sx={{ color: "white" }} />
                        </ListItemIcon>
                        <div className="d-flex flex-column">
                            <span>{auth?.user?.first_name} {auth?.user?.last_name}</span>
                            <span className="small">{auth?.user?.email}</span>
                        </div>
                    </ListItemButton>
                </ListItem>
                <hr className="m-0" style={{ borderColor: '#020304 ' }} /> */}
                <ListItem key="icons_group" className="d-flex justify-content-end p-2" disablePadding>
                    {/* <SpeakerNotes sx={iconStyle} />
                        <Notifications sx={iconStyle} />
                        <AccountCircle sx={iconStyle} /> */}
                    <div title='Logout' >
                        <ExitToApp sx={iconStyle} onClick={() => handleLogout()} />
                    </div>
                </ListItem>
            </List>
        </Box>
    );
}

export default SideNav;
